import { createAction, props } from '@ngrx/store';
import { EstreamContractStatus } from 'brain-data/model/estream-contract-status.model';

export const loadEstreamContractStatus = createAction(
  '[EstreamContractStatus] load',
  props<{ contractNumber: string }>(),
);

export const loadEstreamContractStatusSuccess = createAction(
  '[EstreamContractStatus] load success',
  props<{ contractNumber: string; status: EstreamContractStatus }>(),
);

export const loadEstreamContractStatusError = createAction(
  '[EstreamContractStatus] load error',
  props<{ contractNumber: string; error: Error }>(),
);
